export default {
	content: 'See how this make and model is performing',
	heading: 'Motorway insights',
};
